import { Link } from 'wouter';
import { memo } from 'react';

export const locations = [
  { name: "Dubai", href: "/web-design-dubai" },
  { name: "Al Ain", href: "/web-design-al-ain" },
  { name: "Sharjah", href: "/web-design-sharjah" },
  { name: "Ajman", href: "/web-design-ajman" },
  { name: "Fujairah", href: "/web-design-fujairah" },
  { name: "Ras Al Khaimah", href: "/web-design-ras-al-khaimah" },
  { name: "Umm Al Quwain", href: "/web-design-umm-al-quwain" },
  { name: "UAE", href: "/web-design-uae" },
  { name: "USA", href: "/web-design-usa" },
  { name: "UNITED ARAB EMIRATES", href: "/web-design-development" }
] as const;

const cities = [
  { name: "Dubai", href: "/web-design-dubai" },
  { name: "Al Ain", href: "/web-design-al-ain" },
  { name: "Sharjah", href: "/web-design-sharjah" },
  { name: "Ajman", href: "/web-design-ajman" },
  { name: "Fujairah", href: "/web-design-fujairah" },
  { name: "Ras Al Khaimah", href: "/web-design-ras-al-khaimah" },
  { name: "Umm Al Quwain", href: "/web-design-umm-al-quwain" },
  { name: "UAE", href: "/web-design-uae" },
  { name: "USA", href: "/web-design-usa" },
  { name: "UNITED ARAB EMIRATES", href: "/web-design-development" }
];

const services = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Contact", href: "/contact" },
  { name: "Careers", href: "/careers" },
  { name: "Blog", href: "/blog" },
  { name: "Services", href: "/services" },
  { name: "Portfolio", href: "/portfolio" },
  { name: "Data Analytics", href: "/data-analytics" },
  { name: "Privacy Policy", href: "/privacy-policy" },
  { name: "Terms of Service", href: "/terms-of-service" },
  { name: "Cookie Policy", href: "/cookie-policy" },
  { name: "Software Development", href: "/software-development" },
  { name: "Web Design", href: "/web-design-development" },
  { name: "Mobile App", href: "/mobile-app-development" },
  { name: "Digital Marketing", href: "/digital-marketing" },
  { name: "Ecommerce", href: "/ecommerce" },
  { name: "Consulting", href: "/consulting" },
  { name: "Branding", href: "/branding" },
  { name: "UI/UX", href: "/ui-ux" },
  { name: "SEO", href: "/seo" },
  { name: "Email Hosting", href: "/email-hosting" },
  { name: "Web Hosting", href: "/web-hosting" },
  { name: "Domain Registration", href: "/domain-registration" },
  { name: "ERP/CRM", href: "/erp-crm" },
  { name: "Cloud Services", href: "/cloud-services" },
  { name: "Cyber Security", href: "/cyber-security" },
  { name: "Maintenance", href: "/maintenance-support" },
  { name: "Custom Apps", href: "/custom-apps" },
  { name: "Web Design Dubai", href: "/web-design-dubai" },
  { name: "Web Design Al Ain", href: "/web-design-al-ain" },
  { name: "Web Design Sharjah", href: "/web-design-sharjah" },
  { name: "Web Design Ajman", href: "/web-design-ajman" },
  { name: "Web Design Fujairah", href: "/web-design-fujairah" },
  { name: "Web Design Ras Al Khaimah", href: "/web-design-ras-al-khaimah" },
  { name: "Web Design Umm Al Quwain", href: "/web-design-umm-al-quwain" },
  { name: "Web Design UAE", href: "/web-design-uae" },
  { name: "Web Design USA", href: "/web-design-usa" },
  { name: "Future Web Development", href: "/blog/future-web-development-2024" },
  { name: "Scalable Mobile Apps", href: "/blog/scalable-mobile-apps-react-native" },
  { name: "Digital Marketing Trends", href: "/blog/digital-marketing-trends-uae-2024" },
  { name: "Cybersecurity Practices", href: "/blog/cybersecurity-best-practices-small-business" }
];

const WebDesignLocations = memo(() => {
  return (
    <section className="py-16 bg-gradient-to-b from-blue-50/50 to-white" aria-label="Web design service locations">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Web Design Services Across the UAE & USA
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Professional web design solutions tailored for your city
          </p>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl mx-auto">
          {cities.map((city) => (
            <Link 
              key={city.name} 
              href={city.href}
              className="group block rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg"
              aria-label={`Web design services in ${city.name}`}
            >
              <div className="bg-white p-6 text-center h-full border border-gray-200 rounded-lg hover:border-primary/30 transition-colors">
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-primary transition-colors mb-2">
                  {city.name}
                </h3>
                <span className="text-sm text-primary/80 group-hover:text-primary">
                  Explore Services →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 mt-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore all our professional services
          </p>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 max-w-5xl mx-auto">
          {services.map((service) => (
            <Link 
              key={service.name} 
              href={service.href}
              className="group block rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg"
              aria-label={`${service.name} services`}
            >
              <div className="bg-white p-6 text-center h-full border border-gray-200 rounded-lg hover:border-primary/30 transition-colors">
                <h3 className="text-lg font-semibold text-gray-800 group-hover:text-primary transition-colors mb-2">
                  {service.name}
                </h3>
                <span className="text-sm text-primary/80 group-hover:text-primary">
                  Explore →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
});

WebDesignLocations.displayName = 'WebDesignLocations';
export default WebDesignLocations;
